import React from 'react';
import { Dropdown } from 'react-bootstrap';
import AdminListStatus from './../AdminListStatus';
import RequestorListTrainingCompleted from './RequestorListTrainingCompleted';

function TrainingCompletedDropdown({ trainingStatuses, selectedTrainingStatuses, handleTrainingStatusChange, setSelectedTrainingStatuses }) {
    return (
        <Dropdown className="d-inline-block">
            <Dropdown.Toggle className="p-0" id="statusFilterDropdown">
                Training Completed
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <form>
                    {trainingStatuses.map((trainingStatus) => (
                        <RequestorListTrainingCompleted
                            selectedTrainingStatuses={selectedTrainingStatuses}
                            key={trainingStatus.id}
                            trainingStatus={trainingStatus.value}
                            id={trainingStatus.id}
                            onClick={handleTrainingStatusChange}
                        />
                    ))}
                </form>
                <div>
                    <input
                        type="button" value="Clear All"
                        className="btn btn-link"
                        onClick={() => setSelectedTrainingStatuses([])}
                    /> 
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default TrainingCompletedDropdown;
